import React from "react";
import "./privacyAgreement.scss";
export default function () {
  return (
    <div className="privacy-agreement">
      <div className="title">隐私协议</div>
      <div className="content">
        汇信钱包App是为用户提供数字资产安全管理服务和相关服务的手机端数字资产安全管理服务平台（以下简称“平台”）。平台依据本协议（定义见下文）的规定为在平台进行注册的用户（以下简称“用户”）提供服务，本协议在用户和平台之间具有法律约束力。平台在此特别提醒用户认真阅读并充分理解本协议项下的各条款，特别是本协议中涉及免除或限制平台责任的条款，以及排除或限制用户权利的条款。用户应当审慎阅读，并选择接受或不接受本协议。除非用户接受本协议项下的所有条款，否则用户无权使用平台基于本协议所提供的服务。若用户不同意本协议的内容，或拒绝承认平台随时对本协议进行单方修改的权利，则用户应当立即停止使用并不再访问本平台。用户一经注册成为用户或使用平台服务即视为对本协议全部条款（包括本公司对本协议随时做出的任何修改）充分理解并完全接受。
      </div>
      <div className="content">
        为了本协议表述之方便，本平台在本协议中合称使用“我们”或其他第一人称称呼；访问平台的自然人或其他主体均称为“用户/您”或其他第二人称；我们和用户在本协议中合称为“双方”，我们或用户称为“一方”。
      </div>
      <div className="second-title">第一章 定义和解释</div>
      <div className="content">
        第一条
        在本协议中，除非本协议项下条款另有约定，以下词汇或者表述应当具有下述意义：
        (一)
        本协议应当包括本服务协议、隐私条款和法律声明以及其他在平台上已经发布或将来可能发布的各类规则、附件、声明、说明或指引等构成。{" "}
        <br />
        (二)
        不可抗力：包括信息网络设备维护、信息网络连接故障、电脑、通讯或其他系统的故障、电力故障、天气原因、意外事故、罢工、劳动争议、暴乱、起义、骚乱、生产力或生产资料不足、火灾、洪水、风暴、爆炸、战争或其他合作方原因、数字资产市场崩溃、政府行为、司法或行政机关的命令、其他不在平台可控范围内或平台无能力控制的情形。{" "}
        <br />
        (三)
        创建或导入钱包：指在用户接受本协议后，使用平台创建或导入钱包的过程。{" "}
        <br />
        (四)
        关联公司：与其他公司之间存在直接或间接控制关系或重大影响关系的公司。{" "}
        <br />
        (五)
        公钥：由私钥借助密码学原理单向推导生成，并用以生成区块链数字钱包地址，数字钱包地址即为公开收款地址。{" "}
        <br />
        (六)
        汇信钱包（或钱包）：基于区块链开发的数字资产钱包，包括其他为方便用户使用区块链系统而开发的辅助工具。{" "}
        <br />
        (七)
        钱包密码：指用户在创建钱包过程中，用户应当决定密码，该密码将被用于加密和保护私钥。汇信钱包系去中心化的应用，钱包密码不储存在用户的移动设备或平台服务器，一旦用户丢失或忘记密码，用户需要借助私钥或助记词，设置新的钱包密码。{" "}
        <br />
        (八) 身份：基于用户的公私钥对生成的数字识别身份。 <br /> (九)
        使用指南：指在用户使用平台前和/或往后的使用过程中，平台为用户提供的，帮助用户了解区块链基础知识和平台基本操作程序的指南。
        (十) 私钥：由256位随机字符构成，是用户拥有并使用数字资产的关键。 <br />{" "}
        (十一)
        信息提示：平台操作界面涉及的信息提示内容，建议用户按照相关步骤进行操作。
        (十二) 消息中心：用户可以接收平台发出的信息或通知的收件箱。 <br />{" "}
        (十三) 知识产权：应当具有本协议第九十二条之意义。 <br /> (十四)
        助记词：符合区块链BIP39行业标准，由随机算法生成的12（或15/18/21/24）个有序单词组成。是私钥的易记录表现形式，方便用户备份保管。
      </div>
      <div className="content">
        第二条
        在本协议中引用的任何法典或者成文法令或者行政规章应当引用其最新的修订版本，无论该修订是在本协议签订之前或者之后做出。
      </div>
      <div className="content">
        第三条
        本协议中任何条款之标题的应用是出于简便的考量，而不应当用于解释协议条款之用途。引用任何陈述，条款，附件，表格是指本协议项下之陈述，条款，附件，表格。
      </div>
      <div className="content">
        第四条
        本协议项下，除非协议中另有要求，在任何情形下使用“包括”一词，应当具有“包括但不限于”之意义。
      </div>
      <div className="content">
        第五条
        除非本协议条款另有约定，本协议项下的各个文件相互冲突或者不一致，应当以下述顺序来决定文件的效力以解决冲突或者不一致：
        <br />
        (一) 汇信钱包App用户服务协议；
        <br /> (二) 汇信钱包App隐私条款；
        <br /> (三) 其他协议、规则和指引。
      </div>
      <div className="content">
        第六条
        用户可以选择使用平台的不同语言版本，若存在平台的不同语言版本之内容不一致或者相冲突，或遗漏内容之情形，平台的中文文本应当优先适用。
      </div>
      <div className="second-title">第二章 平台基本条款</div>
      <div className="content">
        第七条
        平台系数字资产安全管理服务平台，平台服务是由本公司通过平台及客户端等各种方式向用户提供的服务，具体服务内容主要包括：数字资产安全管理服务、数字资产交易信息发布、用户服务等辅助服务，具体详情平台实际提供的服务内容为准。
      </div>
      <div className="content">
        第八条
        为了保障用户的权益，用户在自愿使用平台服务前，必须仔细阅读并充分理解知悉本服务协议所有条款。一经使用平台服务，即视为对本协议和平台对本协议随时做出的任何修改的充分理解和接受；如有违反而导致任何法律后果，用户将自己独立承担相应的法律责任。
      </div>
      <div className="content">
        第九条
        在本协议履行过程中，平台可根据情况对本协议进行修改。一旦本协议的内容发生变动，平台将公布最新的服务协议，不再向用户作个别通知。如果用户不同意平台对本协议所做的修改，用户有权停止使用平台服务。如果用户继续使用平台服务，则视为用户接受平台对本协议所做的修改，并应遵照修改后的协议执行。
      </div>
      <div className="content">
        第十条
        平台对于用户的通知及任何其他的协议、告示或其他关于用户使用服务的通知，用户同意平台可通过平台公告、站内信、电子邮件、手机短信、无线通讯装置等电子方式或邮寄等物理方式进行，该等通知于发送之日视为已送达收件人（如以邮寄方式向用户发出通知的，则在该等通知按照用户在平台留存的联系地址交邮后的第三个自然日即视为送达）。因不可归责于平台的原因（包括电子邮件地址、手机号码、联系地址等不准确或无效、信息传输故障等）导致用户未在前述通知视为送达之日收到该等通知的，平台不承担任何责任。
      </div>
      <div className="content">
        第十一条
        为了尽可能避免任何对货币钱包的误操作或数字代币的任何安全风险，用户应避免在不具备区块链基础知识的前提下使用平台。对不具备区块链基础知识的用户，本公司有权拒绝提供部分或全部的服务功能。
      </div>
      <div className="content">
        第十二条
        用户理解存在如下情形时，本公司将暂停提供服务（或在发生如下情形时彻底终止服务）：
        <br />
        (一)
        因设备、区块链系统维修、升级、故障和通信中断等技术原因而中断平台的运营；
        <br />
        (二)
        因不可抗力等因素造成平台不能提供服务平台合理认为继续提供服务会有较大风险的；
        <br />
        (三) 适用法律或政策发生重大不利变化的；或
        <br /> (四) 发生平台无法控制或合理预见的其他情形。
      </div>
      <div className="content">
        第十三条
        若平台变更、中断或终止服务时，用户有权在合理的时间内导出钱包信息。
      </div>
      <div className="second-title">第三章 创建钱包</div>
      <div className="content">
        第十四条 在使用平台服务前，用户必须先在平台上创建钱包。
      </div>
      <div className="content">
        第十五条
        创建钱包的个人用户应当是年满十八岁或根据其所在国法律规定具有完全民事权利和民事行为能力，能够独立承担民事责任的自然人
      </div>
      <div className="content">
        第十六条
        欲创建钱包的法人、组织或其他机构，应当指定年满十八岁或根据其所在国法律规定具有完全民事权利和民事行为能力，能够独立承担民事责任的自然人代表机构完成钱包创建。
      </div>
      <div className="content">
        第十七条
        用户第一次创建钱包时，会弹出本协议，用户一旦点击同意按钮，即表示用户或用户有权代理的机构同意本协议的全部内容，且用户本人或用户所代理的机构受到本协议之约束。若用户不具备本协议第十五条或第十六条所要求之主体资格，则用户及用户有权代理的机构应承担因此而导致的一切后果，且平台保留向用户及用户有权代理机构追究责任的权利。
      </div>
      <div className="content">
        第十八条
        在创建钱包前或者创建钱包后，平台有权根据用户所在国家或地区的法律法规、规则、命令等规范的要求，拒绝向用户提供服务。
      </div>
      <div className="content">
        第十九条 用户在此承诺以下事项： <br /> (一)
        出于合法目的创建钱包及使用本平台服务，且不具有以平台为媒介违反法律法规之意图；
        <br />
        (二) 用户保证存入汇信钱包的数字资产来源合法；
        <br /> (三)
        除本协议以外，用户应同时遵守平台不时发布及更新的全部规则，包括公告、使用流程说明、风险提示等。
      </div>
      <div className="content">
        第十九条 用户在此承诺以下事项：
        <br /> (一)
        出于合法目的创建钱包及使用本平台服务，且不具有以平台为媒介违反法律法规之意图；
        <br />
        (二) 用户保证存入汇信钱包的数字资产来源合法；
        <br /> (三)
        除本协议以外，用户应同时遵守平台不时发布及更新的全部规则，包括公告、使用流程说明、风险提示等。
      </div>
      <div className="content">
        第二十条 若用户违背本协议第十九之承诺： <br />
        (一)
        平台有权停止或拒绝用户使用平台服务的部份或全部功能。在此情况下，平台不承担任何责任，并且用户同意负担因此所产生的直接或间接的任何支出或损失；
        <br />
        (二)
        用户应当承担因违背承诺而产生的任何直接或间接损失及不利后果，且平台保留追究用户责任的权利。
        <br />
        第二十一条
        用户系自愿使用平台服务，平台没有以任何方式强迫、诱导、欺骗或者通过其他不公平的手段对用户施加影响。
        <br />
      </div>
      <div className="second-title">第四章 注册平台服务的内容</div>
      <div className="content">
        第二十二条 平台对完成注册的用户提供以下服务： <br />
        (一) 数字资产安全管理服务；
        <br /> (二) 数字资产各项目的实时行情及交易信息；
        <br /> (三) 数字资产兑换服务； <br />
        (四) 提供客户服务；
        <br /> (五) 保障平台正常运营的技术和管理服务；
        <br /> (六) 平台公示的其他服务
      </div>
      <div className="content">
        第二十三条 本协议第二十二条所述之数字资产安全管理服务应当包括以下内容：
        <br />
        (一)
        导入账户：钱包汇信钱包支持的数字资产，用户可以使用汇信钱包生成新钱包或导入相关区块链的系统的其它钱包工具生成的兼容钱包。
        <br />
        (二)
        转账、收款：可以使用户汇信钱包的转账、收款功能进行数字代币的管理，即运用私钥进行电子签名，对相关区块链的账本进行修改。转账是指付款方利用收款方的ENS域名或区块链地址进行转账操作，该“转账”行为涉及在相关区块链系统的分布式账本中对该交易的有效记录（而非在汇信上实际交付或转让数字代币）。
        <br />
        (三) 行情查看：用户可以使用汇信钱包查看第三方提供的数字代币汇率价格。
        <br />
        (四)
        管理数字代币：用户可以从汇信钱包操作界面在默认钱包之外，导入、保管或移除其他的数字资产钱包。
        <br />
        (五)
        币币兑换：用户可以使用第三方提供的数字资产兑换服务，由汇信钱包作为界面工具帮助用户和第三方服务提供方交互并显示数字资产兑换的相应结果。
        <br />
        (六)
        交易记录：平台将从链上获取并显示用户全部或部分的交易记录，但用户应以区块链的最新交易记录为准。
        <br />
        (七)
        暂停服务：基于区块链交易“不可撤销”的属性，平台不能为用户撤回或撤销交易操作，但在一定情况下，平台可以暂停或者限制某位用户对平台的操作。
      </div>
      <div className="content">
        第二十四条 用户在接收本协议第二十二条规定之服务时同意并了解： <br />
        (一)
        秉承着区块链的去中心化特点，并为了保护用户数字代币安全，平台提供的是去中心化服务，区别于银行业金融机构。用户了解并接受，平台不承担以下责任：
        <br />
        (1)
        存储用户的钱包密码（即用户创建/导入钱包时设置的密码）、私钥、助记词或Keystore；
        <br />
        (2) 找回用户的钱包密码、私钥、助记词或Keystore；
        <br /> (3) 冻结钱包；
        <br /> (4) 挂失钱包； <br />
        (5) 恢复钱包；或 <br /> (6) 交易回滚。 <br />
        (二)
        用户应当自行承担保管含有货币钱包的移动设备、备份汇信钱包信息、备份钱包密码、助记词、私钥及Keystore的责任。如用户遗失移动设备、删除且未备份的汇信钱包信息、删除且未备份钱包、钱包被盗或遗忘钱包密码、私钥、助记词或Keystore，平台均无法还原钱包或找回钱包密码、私钥、助记词或Keystore；如用户进行兑换交易时误操作（例如输错转账地址、输错兑换数额），平台无法取消交易，且平台亦不应对此承担任何责任。
        <br />
        (三)
        平台所能够提供的数字代币管理服务并未包括所有已存在的数字资产，请勿通过平台操作任何平台不支持的数字资产。
        <br />
        (四)
        平台提供之币币兑换功能的实质是用户使用第三方智能合约在区块链系统上进行的数字代币兑换。对于第三方智能合约提供的服务，平台仅为用户提供第三方智能合约的使用工具，不对第三方智能合约的功能或服务质量提供任何担保。用户在该第三方智能合约上接受服务或进行交易前应自行判断和评估该第三方智能合约提供的服务或交易是否存在风险。用户应仔细阅读并同意相关智能合约的不断更新的用户协议后方可进行交易。
        <br />
        (五)
        用户了解并同意遵循平台发布的信息提示，按照信息提示的内容进行操作，否则，由此引起的一切风险、责任、损失、费用等应由用户自行承担。
        <br />
        (六)
        平台合理认为用户的交易行为或交易情况出现异常的，或认为用户的身份信息存在疑点的，或平台认为应要求用户提交并核实用户身份证件或其他必要文件的情形时，用户应当积极配合平台核对用户的有效身份证件或其他必要文件，及时完成相关的身份验证。用户了解并接受，平台可以限制、暂停或终止用户使用平台直到用户提供满足平台要求的信息。
        <br />
        (七) 转账。
        <br /> (1)
        用户知悉对于平台服务中用户可使用的日计转账限额和笔数，可能因为用户使用该转账服务时所处的国家/地区、监管要求、转账目的、平台风险控制、身份验证等事由而不同。
        <br />
        (2)
        用户理解基于区块链操作的“不可撤销”属性，当用户使用转账功能时，用户应当自行承担因用户操作失误而导致的后果（包括但不限于因用户输错转账地址、用户自身选择转账节点服务器的问题）。
        <br />
        (3)
        用户知悉在使用平台服务时，以下情况的出现可能导致转账功能不可用、转账“交易失败”或“打包超时”：
        <br />
        a) 钱包余额不足；
        <br /> b) 交易矿工费不足；
        <br /> c) 区块链执行智能合约代码失败；
        <br /> d) 超出监管部门、平台或法律法规规定的付款额度；
        <br /> e) 网络、设备等技术故障；
        <br />
        f) 区块链网络拥堵、故障等原因引起交易被抛弃；
        <br /> g) 用户的地址或交易对方地址被识别为特殊地址，如高风险地址。
        <br /> (4)
        用户知悉平台仅向用户提供转账工具，在用户使用平台完成转账后，本公司即完成了当次服务的所有义务，本公司对其他相关纠纷争议，不承担任何责任。
        <br />
        (八)
        用户知悉，币币兑换的每日限额目前由第三方智能合约限定。平台亦可能对用户每日币币兑换的额度进行限制并不时调整。
        <br />
        (九)
        用户知悉，在平台进行操作时或利用平台第三方之智能合约进行交易时，用户应当遵循有关法律法规、国家政策的要求。
        <br />
      </div>
      <div className="content">
        第二十五条
        除了本协议第二十二条项下所列之服务，和平台公示的技术性服务，平台不能就数字资产交易提供给用户任何投资、法律、税收或其他专业意见，且平台所提供之任何消息、探讨、分析、价格等信息均为一般评论，不构成对用户进行任何数字资产交易的建议。如果用户需要专业意见，用户应当向相关专业人士咨询数字货币交易有关的投资、法律、税收或其他专业性建议。平台不承担用户因依赖上述一般评论而产生的任何直接或间接而产生的损失（包括任何利润损失）。
      </div>
      <div className="content">
        第二十六条
        平台提供的服务不应当理解为或被用于向任何认定平台所提供之服务为非法的国家或地区的用户发出要约。
      </div>
      <div className="content">
        第二十七条
        平台有权基于下述原因修改、暂停或永久停止对用户开放的平台之部分或全部服务：
        <br />
        (一) 依据用户所属主权国家或地区的法律法规、规则、命令等规范的要求；
        <br /> (二) 平台出于保护平台或客户利益之合法利益；
        <br /> (三) 其他合理理由。
      </div>
      <div className="content">
        第二十八条
        平台基于本协议第二十七条修改、暂停或永久停止对用户开放的平台之部分或全部服务的，生效日以平台公告为准。
      </div>
      <div className="second-title">第五章 账户安全及管理</div>
      <div className="content">
        第二十九条
        用户了解并同意，确保用户设置密码及密码的机密安全是用户的责任。用户将对利用该用户账户及密码所进行的一切行动及言论，负完全的责任，并同意以下事项：
        <br />
        (一)
        用户应根据平台的相关规则以及平台的相关提示创建密码，应避免选择过于明显的单词或日期，比如用户的姓名、昵称或者生日等；
        <br />
        (二)
        用户创建密码时，应当满足平台所列举之四项要求，当满足某一项要求时，屏幕会出现提示，有且只有当四项要求全部满足时，才能完成密码输入；
        <br />
        (三)
        密码输入后用户需要第二次输入密码进行核实，当两次密码不一致时，平台会弹出信息提示；
        <br />
        (四) 只有在两次输入密码一致后，平台才会弹出密码创建成功的信息提示；
        <br /> (五)
        用户不对其他任何人泄露密码，亦不可使用其他任何人的密码。因黑客、病毒或用户的保管疏忽等非平台原因导致用户的用户账户遭他人非法使用的，平台不承担任何责任；
        <br />
        (六)
        用户禁止在未经平台同意的情形下不得将创建之钱包以赠与、借用、租用、转让或以其他方式处分给第三方；
        <br />
        (七)
        用户确认，使用密码导入后在平台的一切行为均代表用户本人。用户操作所产生的电子信息记录均为用户行为的有效凭据，并由用户本人承担由此产生的全部责任；
        <br />
        (八) 在平台通知用户可能预见的安全风险后，采取措施保障密码安全；
        <br /> (九)
        冒用他人密码的，平台及其合法授权主体保留追究实际使用人连带责任的权利。
      </div>
      <div className="content">
        第三十条
        用户如发现有第三人冒用或盗用用户密码，或其他任何未经合法授权的情形，应立即以有效方式通知平台，要求平台暂停相关服务，否则由此产生的一切责任由用户本人承担。同时，用户理解用户对用户的请求采取行动需要合理期限，在此之前，平台对第三人使用该服务所导致的损失不承担任何责任。
      </div>
      <div className="content">
        第三十一条
        用户应自行承担妥善保管移动设备、钱包密码、私钥、助记词和Keystore等信息的责任。
        本公司不负责为用户保管以上信息。因用户遗失移动设备、主动或被动泄露、遗忘钱包密码、私钥、助记词、Keystore或遭受他人攻击、诈骗等所引起的一切风险、责任、损失、费用应由用户自行承担。
      </div>
      <div className="content">
        第三十二条
        平台有权基于单方独立判断，在其认为可能发生危害交易安全等情形时，不经通知而先行暂停、中断或终止向用户提供本协议项下的全部或部分服务（包括收费服务），且无需对用户或任何第三方承担任何责任。前述情形包括：
        <br />
        (一) 用户死亡；
        <br /> (二) 平台发现钱包数字资产或有疑义或有违法之虞时；
        <br /> (三)
        平台认为用户涉嫌洗钱、套现、传销、被冒用或其他平台认为有风险之情形；
        <br />
        (四) 用户盗用他人的钱包信息或移动设备；
        <br /> (五) 在向平台提供信息时提供虚假信息；
        <br /> (六) 拒绝平台的强制更新操作；
        <br /> (七) 散布谣言，损害平台商誉；
        <br /> (八)
        平台发现用户使用非法或不正当的技术手段进行危害数字资产管理安全的行为；
        <br />
        (九) 平台认为用户已经违反本协议中规定的各类规则及精神；
        <br /> (十) 用户创建钱包已连续一年内未登录或实际使用且数字资产为零；
        <br /> (十一) 用户违反本协议的其他情形。
      </div>
      <div className="content">
        第三十三条
        用户同意，如其用户账户未完成身份认证且已经连续一年未登陆，平台无需进行事先通知即有权终止提供用户账户服务，并可能立即暂停、关闭或删除用户账户及该用户账户中所有相关资料及档案。
      </div>
      <div className="content">
        第三十四条
        用户同意，用户账户的暂停、中断或终止不代表用户责任的终止，用户仍应对使用平台服务期间的行为承担可能的违约或损害赔偿责任，同时平台仍可保有用户的相关信息。
      </div>
      <div className="second-title">第六章 用户的保证及承诺</div>
      <div className="content">
        第三十五条
        用户承诺绝不为任何非法目的或以任何非法方式使用平台服务，并承诺遵守其所在国的相关法律、法规及一切使用互联网之国际惯例，遵守所有与平台服务有关的网络协议、规则和程序。
      </div>
      <div className="content">
        第三十六条
        用户同意并保证不得利用平台服务从事侵害他人权益或违法之行为，若有违反者应负所有法律责任。
        上述行为包括：
        <br /> (一) 冒用他人名义使用平台服务； <br />
        (二)
        从事任何不法交易行为，如贩卖枪支、毒品、禁药、盗版软件或其他违禁物；
        <br />
        (三) 提供赌博资讯或以任何方式引诱他人参与赌博； <br />
        (四) 涉嫌洗钱、套现或进行传销活动的；
        <br /> (五)
        从事任何可能使用或散播电脑病毒或是可能侵害平台服务系統、资料等行为；
        <br />
        (六)
        利用平台服务系统进行可能对互联网或移动网正常运转造成不利影响之行为；
        <br />
        (七) 恶意干扰数字资产交易正常进行，破坏数字资产交易秩序；
        <br /> (八)
        利用任何技术手段或其他方式干扰平台正常运行或干扰其他用户对平台服务的使用；
        <br />
        (九) 以虚构、夸大事实等方式恶意诋毁平台商誉；
        <br /> (十) 其他平台有正当理由认为不适当之行为。
      </div>
      <div className="content">
        第三十七条
        平台保有依其单独判断删除平台内各类不符合法律政策或不真实或不适当的信息内容而无须通知用户的权利，并无需承担任何责任。若用户未遵守以上规定的，平台有权做出独立判断并采取暂停或关闭用户账户等措施，而无需承担任何责任。
      </div>
      <div className="content">
        第三十八条
        用户同意，由于用户违反本协议，或违反通过援引并入本协议并成为本协议一部分的文件，或由于用户使用平台服务违反了任何法律或第三方的权利而造成任何第三方进行或发起的任何补偿申请或要求（包括律师费用），用户会对平台及其关联方、合作伙伴、董事以及雇员给予全额补偿并使之不受损害。
      </div>
      <div className="content">
        第三十九条
        用户承诺，其通过平台上传或发布的信息均真实有效，其向平台提交的任何资料均真实、有效、完整、详细、准确。如因违背上述承诺，造成平台或平台其他使用方损失的，用户将承担相应责任。
      </div>
      <div className="content">
        第四十条
        用户理解并同意，平台向符合条件的用户提供服务。平台对在平台上进行的数字资产投资或交易行为不承担任何责任，平台无法也没有义务保证用户投资成功，用户因投资或交易数字资产原因导致的损失由用户自行承担，平台不承担责任。
      </div>
      <div className="content">
        第四十一条
        用户同意对其平台注册账号下发生的所有活动（包括信息披露、发布信息、点击同意各类协议、上传提交各类文件、点击同意续签各类协议或点击同意数字货币交易等）承担责任，且如在上述活动进程中，若用户未遵从本协议条款或平台公布的交易规则中的操作指示的，平台不承担任何责任。
      </div>
      <div className="content">
        第四十二条
        用户同意，平台有权在提供平台服务过程中以各种方式投放各种商业性广告或其他任何类型的商业信息（包括在平台的任何页面上投放广告），并且，用户同意接受平台通过电子邮件或其他方式向用户发送商业促销或其他相关商业信息。
      </div>
      <div className="content">
        第四十三条
        用户同意，若用户因数字资产交易与项目方或其他第三方产生纠纷的，不得通过司法或行政以外的途径要求平台提供相关资料。
      </div>
      <div className="second-title">第七章 服务中断或故障</div>
      <div className="content">
        第四十四条
        用户同意，基于互联网的特殊性，平台不担保服务不会中断，也不担保服务的及时性和/或安全性。系统因相关状况无法正常运作，使用户无法使用任何平台服务或使用任何平台服务时受到任何影响时，平台对用户或第三方不负任何责任，前述状况包括：
        <br />
        (一) 平台系统停机维护期间。 <br />
        (二) 电信设备出现故障不能进行数据传输的。
        <br />
        (三)
        由于黑客攻击、网络供应商技术调整或故障、网站升级的问题等原因而造成的平台服务中断或延迟。
        <br />
        (四)
        因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素，造成平台系统障碍不能执行业务的。
      </div>
      <div className="second-title">第八章 责任范围及限制</div>
      <div className="content">
        第四十五条 平台未对任何平台服务提供任何形式的保证，包括以下事项： <br />
        (一) 平台服务将符合用户的需求。 <br />
        (二) 平台服务将不受干扰、及时提供或免于出错。
        <br />
        (三)
        用户经由平台服务购买或取得之任何产品、服务、资讯或其他资料将符合用户的期望。
        <br />
        (四)
        平台包含的全部信息、程序、文本、数据等完全安全，不受任何病毒、木马等恶意程序的干扰和破坏。
        <br />
        (五)
        所有的交易结果计算都经过平台核实，相应的计算方法都会在平台上进行公示，但是平台不能保证其计算没有误差或不受干扰。
      </div>
      <div className="content">
        第四十六条
        用户知悉并同意，在任何情形下，平台不会就下列任一事项承担责任：
        <br /> (一) 用户的收入损失；
        <br /> (二) 用户的交易利润或合同损失；
        <br /> (三) 服务中断、中止或终止而引起的损失；
        <br /> (四) 预期可节省交易成本的损失；
        <br /> (五) 信息传递问题而造成的损失；
        <br /> (六) 措施投资或交易机会的损失；
        <br /> (七) 商誉或声誉的损失；
        <br /> (八) 数据的遗失或损坏而造成的损失；
        <br /> (九) 购买替代产品或服务的开销；
        <br /> (十)
        任何由于侵权（包括故意和过失）、违约、或其他任何原因导致的间接的、特殊的或附带性的损失，不论此种损失是否为平台所能合理预见，亦不论平台是否事先被告知存在此种损失的可能性；
        <br />
        (十一)
        因用户遗失移动设备、删除且未备份汇信钱包信息、遗忘且未备份钱包密码、私钥、助记词、Keystore而导致该用户的数字代币丢失；
        <br />
        (十二)
        因用户自行泄露钱包密码、私钥、助记词、Keystore，或借用、转让或授权他人使用自己的移动设备或汇信钱包，或未通过本公司官方渠道下载平台应用程序或以其他不安全的方式使用平台应用程序导致的用户的数字代币丢失；
        <br />
        (十三)
        因用户错误操作（包括但不限于用户输错转账地址、用户自身选择转账节点服务器的问题）导致的数字代币丢失；
        <br />
        (十四)
        因用户不理解区块链技术的知识而进行误操作导致的该用户的数字代币丢失；
        <br />
        (十五)
        因系统滞后、区块链不稳定等原因导致平台拷贝用户在区块链上的交易记录发生偏差。
      </div>
      <div className="content">
        第四十七条
        用户了解并同意，发生以下任一情形时，平台有权拒绝赔偿用户的全部或部分损失：
        <br />
        (一) 平台有合理的理由认为用户在平台的行为系涉嫌违法或不道德行为。
        <br /> (二) 用户误以为系平台原因造成损失的情形；
        <br /> (三) 任何非因平台原因引起的其他损失。
      </div>
      <div className="content">
        第四十八条
        平台服务的合作单位所提供的服务品质及内容由该合作单位自行负责。平台的内容可能涉及由第三方所有、控制或者运营的其他网站（以下简称“第三方网站”）。平台不能保证也没有义务保证第三方网站上任何信息的真实性和有效性。用户确认按照第三方网站的服务协议使用第三方网站，而不是按照本协议。第三方网站的内容、产品、广告和其他任何信息均由用户自行判断并承担风险，而与平台无关。用户经由平台服务的使用下载或取得任何资料，应由用户自行考量且自负风险，因资料的下载而导致的任何损坏由用户自行承担。
      </div>
      <div className="content">
        第四十九条
        用户自平台及平台工作人员或经由平台服务取得的建议或资讯，无论其为书面或口头，均不构成平台对平台服务的任何保证。
      </div>
      <div className="content">
        第五十条
        平台不保证为向用户提供便利而设置的外部链接的准确性、有效性、安全性和完整性，同时，对于该等外部链接指向的不由平台实际控制的任何网页上的内容，平台不承担任何责任。
      </div>
      <div className="content">
        第五十一条
        在法律允许的情况下，平台对于与本协议有关或由本协议引起的，或者，由于使用平台、或由于其所包含的或以其他方式通过平台提供给用户的全部信息、内容、材料、产品（包括软件）和服务、或购买和使用产品引起的任何间接的、惩罚性的、特殊的、派生的损失（包括业务损失、收益损失、利润损失、使用数据或其他经济利益的损失），不论是如何产生的，也不论是由对本协议的违约（包括违反保证）还是由侵权造成的，均不负有任何责任，即使其事先已被告知此等损失的可能性。另外即使本协议规定的排他性救济没有达到其基本目的，也应排除平台对上述损失的责任。
      </div>
      <div className="content">
        第五十二条
        除本协议另有规定外，在任何情况下，平台对本协议所承担的违约赔偿责任总额不超过0.1个以太币的市场价值。
      </div>
      <div className="content">
        第五十三条
        除本协议另有规定外，在任何情况下，因用户违反本协议或其所在国法律法规而导致平台遭受损失的，用户应当赔偿平台所遭受的一切直接和/或间接的损失（包括诉讼费用等）。
      </div>
      <div className="content">
        第五十四条
        平台和用户均承认普通法对违约或可能违约情况的救济措施可能不足以弥补守约方遭受的全部或部分损失，故双方同意，协议一方有权在协议另一方违约或可能违约情况下寻求禁令救济以及普通法或衡平法允许的其他所有的补救措施。
      </div>
      <div className="content">
        第五十五条
        平台在本协议中做出的保证和承诺是平台就其依据本协议提供服务的唯一保证和陈述（以下简称“协议保证”），取代任何其他途径和方式产生的保证和承诺（以下简称“非协议保证”），无论非协议保证是以书面或口头，明示或暗示的形式做出。所有协议保证仅仅由平台做出，对平台自身具有约束力，其效力不能约束任何第三方。
      </div>
      <div className="content">
        第五十六条
        用户知悉并同意，平台并不放弃本协议中未提及的，在法律适用的最大范围内平台所享有的限制、免除或抵销平台损害赔偿责任的任何权利。
      </div>
      <div className="second-title">第九章 风险提示</div>
      <div className="content">
        第五十七条
        数字资产交易有极高风险，并不适合绝大部分人士投资。用户知悉并了解此投资有可能导致部分损失或全部损失，所以用户应当以能承受的损失程度来决定其投资或交易的数量。用户应慎重评估自己的财政状况，及各项风险，而做出任何数字资产投资或交易的决定。用户应当承担由该决定产生的全部损失，平台对用户的投资或交易决定不承担任何责任。
      </div>
      <div className="content">
        第五十八条
        平台不对任何用户及/或任何交易提供任何担保或条件，无论是明示、默示或法定的。平台不能也不试图对用户或项目方发布的信息进行控制，对该等信息，平台不承担任何形式的证明、鉴定服务。平台不能完全保证平台内容的真实性、充分性、可靠性、准确性、完整性和有效性，并且无需承担任何由此引起的法律责任。用户应依赖于用户的独立判断进行交易，用户应对其做出的判断承担全部责任。
      </div>
      <div className="content">
        第五十九条
        鉴于数字资产投资或交易所衍生的风险，若用户对该种投资或交易由任何疑问，应当在交易或投资前事先寻求专业顾问的协助。
      </div>
      <div className="content">
        第六十条
        平台对于用户使用平台服务不做任何明示或暗示的保证，包括但不限于平台提供服务的适用性、没有错误或疏漏、持续性、准确性、可靠性、适用于某一特定用途。同时，我们也不对平台提供的服务所涉及的技术及信息的有效性、准确性、正确性、可靠性、质量、稳定、完整和及时性做出任何承诺和保证。
      </div>
      <div className="content">
        第六十一条
        是否登陆或使用平台提供的服务是用户个人的决定且自行承担风险及可能产生的损失。平台对于数字资产的市场、价值及价格等不做任何明示或暗示的保证，用户知悉并了解数字资产市场的不稳定性，数字资产的价格和价值随时会大幅波动或崩盘，交易数字资产是用户个人的自由选择及决定，且自行承担风险及可能产生的损失。
      </div>
      <div className="content">
        第六十二条
        以上并不能揭示用户通过平台进行交易的全部风险及市场的全部情形。用户在做出交易决策前，应全面了解相关数字资产，根据自身的交易目标、风险承受能力和资产状况等谨慎决策，并自行承担全部风险。
      </div>
      <div className="content">
        第六十三条
        平台提供的行情查看功能仅系抓取部分交易所的数字代币汇率信息的搜索结果，并不表示为最新行情或最佳报价。
      </div>
      <div className="content">
        第六十四条
        在使用平台服务时，若用户或用户的相对方未遵从本协议或相关网站说明、交易、支付页面中之操作提示、规则，平台并不保证交易会顺利完成，且平台不承担损害赔偿责任。若发生前述情形，而款项已先行入账用户的或用户的交易方的汇信钱包或第三方钱包，用户理解区块链操作具有的“不可逆”属性，以及相关交易具有“不可撤销”的特征，由用户及用户的相对方自行承担相应的风险后果。
      </div>
      <div className="content">
        第六十五条
        用户理解并知悉，币币兑换交易在第三方智能合约上发生、进行并完成。平台仅作为界面工具帮助用户和第三方智能合约交互并显示该已完成交易的相应结果。
      </div>
      <div className="content">
        第六十六条
        用户使用平台集成的第三方智能合约服务时，用户应当仔细阅读该第三方智能合约的用户协议、隐私政策和其他相关的文件和信息等，了解交易对象及产品信息，谨慎评估风险后再在该第三方智能合约上进行交易。用户理解该交易和有约束力的合同关系在该用户和该用户的相对方之间建立，与平台无关。平台对因用户的交易行为所引起的一切风险、责任、损失、费用不承担任何责任。
      </div>
      <div className="content">
        第六十七条
        转账过程中，如果出现“交易失败”、“打包超时”等类似的异常信息提示时，用户应通过相关区块链官方途径或其他的区块链查询工具进行再次确认，以避免重复转账；否则，由此所引起的一切损失和费用应由用户自行承担。
      </div>
      <div className="content">
        第六十八条
        用户理解当用户在平台上创建或导入钱包之后，用户的Keystore、私钥、助记词等信息仅存储在当前的这台移动设备中，不存储在平台或平台的服务器上。用户可以按照平台提供的操作指南采取同步钱包等方式更换移动设备。但若用户未保存或备份钱包密码、私钥、助记词、Keystore等信息且在用户移动设备丢失的情况下，用户的数字代币将因此丢失，本公司无法为用户找回。若用户在导出、保存或备份钱包密码、私钥、助记词、Keystore等信息的时候泄密，或保存或备份上述信息的设备或服务器被黑客攻击或控制等情况下，用户的数字代币将因此丢失，本公司无法为用户找回。因前述情形产生的任何及所有损失应由用户自行承担。
      </div>
      <div className="content">
        第六十九条
        用户应当在创建或导入钱包时对用户钱包的钱包密码、私钥、助记词及Keystore等信息做好安全备份。用户禁止采用以下电子备份方式：截图、邮件、手机中的记事本应用、短信、微信、QQ等电子备份方式。用户应当在纸质记事本上抄写助记词和Keystore等信息。
      </div>
      <div className="content">
        第七十条
        用户应当在安全的网络环境中使用平台，确保用户的移动设备没有越狱或root，
        以避免可能存在的安全隐患。
      </div>
      <div className="content">
        第七十一条
        在任何情况下，对于用户使用平台服务过程中涉及由第三方提供相关服务的责任由该第三方承担，平台不承担该等责任。
      </div>
      <div className="content">
        第七十二条
        因用户自身的原因导致的任何损失或责任，由用户自行负责，平台不承担责任。平台不承担责任的情形包括：
        <br />
        (一)
        用户未按照本协议或平台不时公布的任何规则进行操作导致的任何损失或责任；
        <br />
        (二)
        因用户向平台发送的指令信息不明确、或存在歧义、不完整等导致的任何损失或责任；
        <br />
        (三) 用户账户内数字资产余额不足导致的任何损失或责任；
        <br /> (四) 其他因用户原因导致的任何损失或责任。
      </div>
      <div className="second-title">第十章 服务费用及其他费用</div>
      <div className="content">
        第七十三条
        当用户使用平台服务时，平台向用户收取相关平台服务费用。各项平台服务费用详见用户使用平台服务时，平台上所列之收费说明及收费标准。平台保留单方面制定及调整平台服务费用收费标准的权利。
      </div>
      <div className="content">
        第七十四条
        用户使用币币兑换服务时，兑换服务提供合作商会向用户收取手续费和/或服务费，具体费用以合作商收取数额为准，平台信息提示仅供参考。
      </div>
      <div className="content">
        第七十五条
        使用平台进行转账时应支付“矿工费”或网络费，金额由用户自行决定，并由相关区块链网络收取。用户知悉，在特定情况（包括但不限于用户在转账期间为转账支付的“矿工费”或网络费不足，或相关区块链网络不稳定）下，用户的转账操作可能失败；在该等情况下，即便用户的转账操作未完成，用户亦会被相关区块链网络收取矿工费。
      </div>
      <div className="content">
        第七十六条
        因在平台进行交易而发生的所有应纳税负及其它方面的费用均由用户负责支付。
      </div>
      <div className="second-title">第十一章 协议之终止</div>
      <div className="content">
        第七十七条
        用户有权在任何时候向平台申请注销平台钱包，自平台批准用户注销钱包之日起协议终止。
      </div>
      <div className="content">
        第七十八条
        依据本协议第三十二条、三十三条注销账号的，自平台注销用户账号之日起协议终止。
      </div>
      <div className="content">
        第七十九条
        用户死亡或被宣告死亡的，其在本协议项下的各项权利义务由其继承人承担。若用户丧失全部或部分民事权利能力或民事行为能力，平台或其授权的主体有权根据有效法律文书（包括生效的法院判决等）或其法定监护人的指示处置与用户账户相关的款项。若继承人或法定监护人决定继续履行本协议的，则本协议依然有效；反之，则继承人或法定监护人需要依据本协议向平台申请注销账号，自平台批准用户注销账号之日起协议终止。
      </div>
      <div className="content">
        第八十条
        平台有权依据本协议约定终止平台全部服务，本协议于平台全部服务终止之日终止，清退流程根据平台公告的具体规定进行操作。
      </div>
      <div className="content">
        第八十一条
        本协议终止后，用户无权要求平台继续向其提供任何服务或履行任何其他义务，包括但不限于要求平台为用户保留或向用户披露其原本网站账号中的任何信息，
        向用户或第三方转发任何其未曾阅读或发送过的信息等。
      </div>
      <div className="content">
        第八十二条
        本协议的终止不影响守约方向违约方主张其他协议终止前违约方之违约责任，也不影响本协议规定之后合同义务之履行。
      </div>
      <div className="second-title">第十二章 个人信息之保护和授权条款</div>
      <div className="content">
        第八十三条 本协议第十二章中之个人信息应当包括以下信息：
        <br /> (一)
        在用户注册平台账号或者使用账户时，用户根据本平台要求提供的个人注册信息，包括但不限于电话号码、邮箱信息、身份证件信息；
        <br />
        (二)
        在用户使用平台时，或访问平台时，平台自动接收并记录的用户浏览器上的服务器数值，包括但不限于IP地址等数据及用户要求取用的网页记录；
        <br />
        (三) 平台收集到的用户在平台进行交易的有关数据，包括但不限于交易记录；
        <br />
        (四) 平台通过合法途径取得的其他用户个人信息。
      </div>
      <div className="content">
        第八十四条
        不需要用户额外的同意，用户在平台注册成功即视为用户同意平台收集并使用或披露其个人信息，且用户了解并同意，基于为用户度身订造平台服务、解决争议并有助确保在平台进行安全交易的考量，平台可以将收集的用户个人信息用作下列用途包括：
        <br />
        (一) 向用户提供平台服务；
        <br /> (二) 基于主权国家或地区相关主管部门的要求向相关部门进行报告；
        <br /> (三)
        在用户使用平台服务时，平台将用户的信息用于身份验证、客户服务、安全防范、诈骗监测、市场推广、存档和备份用途，或与第三方合作推广网站等合法用途，确保平台向用户提供的产品和服务的安全性；
        <br />
        (四)
        帮助平台设计新产品及服务，改善平台现有服务目的而进行的信息收集和整理；
        <br />
        (五)
        为了使用户了解平台服务的具体情况，用户同意平台向其发送营销活动通知、商业性电子信息以及提供与用户相关的广告以替代普遍投放的广告；
        <br />
        (六)
        平台为完成合并、分立、收购或资产转让而将用户的信息转移或披露给任何非关联的第三方；
        <br />
        (七) 软件认证或管理软件升级；
        <br /> (八) 邀请用户参与有关平台服务的调查；
        <br /> (九) 用于和政府机关、公共事务机构、协会等合作的数据分析；
        <br /> (十) 用于解决争议或对纠纷进行调停；
        <br /> (十一) 用作其他一切合法目的以及经用户授权的其他用途。
      </div>
      <div className="content">
        第八十五条
        平台按照用户在平台上的行为自动追踪关于用户的某些资料。在不透露用户的隐私资料的前提下，平台有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。
      </div>
      <div className="content">
        第八十六条
        用户同意，平台可在平台的某些网页上使用诸如“Cookies”的资料收集装置。
      </div>
      <div className="content">
        第八十七条
        平台根据相关法律法规以保护用户的资料。用户因履行本协议提供给平台的信息，平台不会恶意出售或免费共享给任何第三方，以下情况除外：
        <br />
        (一) 提供独立服务且仅要求服务相关的必要信息的供应商；
        <br /> (二)
        具有合法调阅信息权限并从合法渠道调阅信息的政府部门或其他机构； <br />
        (三) 平台的关联公司；
        <br /> (四) 经平台使用方或平台使用方授权代表同意的第三方。
      </div>
      <div className="content">
        第八十八条
        用户授权平台，除法律另有规定之外，将用户提供给平台的信息、享受平台服务产生的信息（包括本协议签署之前提供和产生的信息）以及平台根据本条约定查询、收集的信息，用于平台及其因服务必要委托的合作伙伴为用户提供服务、推荐产品、开展市场调查与信息数据分析。
      </div>
      <div className="content">
        第八十九条
        用户授权平台，除法律另有规定之外，基于为用户提供更优质服务和产品的目的，向平台因服务必要开展合作的伙伴提供、查询、收集用户的信息。
      </div>
      <div className="content">
        第九十条
        为确保用户信息的安全，平台及其合作伙伴对上述信息负有保密义务，并采取各种措施保证信息安全。
      </div>
      <div className="content">
        第九十一条
        本协议第十二章项下之条款自本协议签署时生效，具有独立法律效力，不受合同成立与否及效力状态变化的影响。
      </div>
      <div className="second-title">第十三章 知识产权的保护</div>
      <div className="content">
        第九十二条
        平台上所有内容，包括著作、图片、档案、资讯、资料、平台架构、平台画面的安排、平台设计，文字和图表，软件编译，相关源代码和软件等均由平台或其他权利人依法拥有其知识产权，包括商标权、专利权、著作权、商业秘密等。
      </div>
      <div className="content">
        第九十三条
        非经平台或其他权利人书面同意，任何人不得擅自使用、修改、复制、公开传播、改变、散布、发行或公开发表平台程序或内容。
      </div>
      <div className="content">
        第九十四条
        用户未经平台的明确书面同意不许下载（除了页面缓存）或修改平台或其任何部分。用户不得对平台或其内容进行转售或商业利用；不得收集和利用产品目录、说明和价格；不得对平台或其内容进行任何衍生利用；不得为其他商业利益而下载或拷贝账户信息或使用任何数据采集、Robots或类似的数据收集和摘录工具。未经平台的书面许可，严禁对平台的内容进行系统获取以直接或间接创建或编辑文集、汇编、数据库或人名地址录（无论是否通过Robots、Spiders、自动仪器或手工操作）。另外，严禁为任何未经本使用条件明确允许的目的而使用平台上的内容和材料。
      </div>
      <div className="content">
        第九十五条
        未经平台明确书面同意，不得以任何商业目的对平台网站或其任何部分进行复制、复印、仿造、出售、转售、访问、或以其他方式加以利用。未经平台明确书面同意，用户不得用任何技巧把平台或其关联公司的商标、标识或其他专有信息（包括图像、文字、网页设计或形式）据为己有。未经平台明确书面同意，用户不得以Meta
        Tags或任何其他"隐藏文本"方式使用平台或其关联公司的名字和商标。任何未经授权的使用都会终止平台所授予的允许或许可。
      </div>
      <div className="content">
        第九十六条
        用户登陆平台或使用平台提供的任何服务均不视为平台向用户转让任何知识产权。尊重知识产权是用户应尽的义务，如有违反，用户应对平台承担损害赔偿等法律责任
      </div>
      <div className="second-title">第十四章 一般条款</div>
      <div className="content">
        第九十七条
        本协议是由用户与平台共同签订的，适用于用户在平台的全部活动。本协议内容包括协议正文条款及已经发布的或将来可能发布的各类规则，所有条款和规则为协议不可分割的一部分，与本协议正文具有同等法律效力。
      </div>
      <div className="content">
        第九十八条
        如本协议中的任何条款被任何有管辖权的机构认定为不可执行的，无效的或非法的，并不影响本协议的其余条款的效力。
      </div>
      <div className="content">
        第九十九条
        本协议中约定的权利及义务同样约束通过转让从该权利义务中获取到利益的各方的受让人，继承人，遗嘱执行人和管理员。用户不得在我们不同意的前提下将本协议项下的权利或义务转让给任何第三方，但平台可随时将我们在本协议中的权利和义务转让给任何第三方，并于转让之日提前三十（30）天给与用户通知。
        第百条
        如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，则应认为该条款可与本协议相分割，并可被尽可能接近各方意图的、能够保留本协议要求的经济目的的、有效的新条款所取代，而且，在此情况下，本协议的其他条款仍然完全有效并具有约束力。
      </div>
      <div className="content">
        第百一条
        除非本协议中的其他条款另有约定，本协议中的任何规定均不应当被认为创造了、暗示了或以其他方式将平台视为用户的代理人、受托人或其他代表人。
      </div>
      <div className="content">
        第百二条
        本协议任何一方未能就单一事件行使与本协议有关的权利或寻求救济，并不影响该缔约方随后就该单一事件或者在其他事件后行使该权利或者寻求救济。
      </div>
      <div className="content">
        第百三条
        对违约行为的豁免，或本协议任一条款的放弃，仅在守约方或非寻求放弃方书面签字同意豁免后方能生效。任何本协议项下的违约豁免，不能认定或解释为守约方对其后再次违约或其他违约行为的豁免；未行使任何权利或救济不得以任何方式被解释为对该等权利或救济的放弃。
      </div>
      <div className="content">
        第百四条
        在提出争议或索赔之前，您确认并同意先联系平台以非正式方式解决纠纷，我们将尝试尽快在内部解决您的争议；双方同意通过善意协商以解决争议(讨论内容应保密，并受适用规则保护而不被用作任何法律程序中的证据)。
      </div>
      <div className="content">
        第百五条
        您确认并同意，如果发生任何争议、争论、分歧或权利主张，包括本条款的存在、有效性、解释、履行、违反或终止或由本条款引起的或与之相关的任何争议（“争议”），无法通过第百四条的约定解决的，上述双方应根据届时有效的《国际商会仲裁规则》将争议提交国际商会国际仲裁院（“ICC国际仲裁院”）。仲裁地点为伯利兹，仲裁的适用法律应根据国际商会仲裁规则确定。除非双方另有约定，否则根据国际商会仲裁规则仅指定一名仲裁员。仲裁员应拥有对其自身管辖权进行裁决的排他性权力，包括但不限于就仲裁协议的存在、范围或有效性或任何索赔或反索赔的可仲裁性提出的任何异议。任何仲裁都将以英语进行。无论仲裁以何种方式进行，仲裁员都应出具一份合理的书面裁决，足以解释裁决和裁决所依据的基本结论和结论(如果有的话)。仲裁裁决应为终局裁决，对各方均具有约束力，并可在任何有管辖权的法院被强制执行。
      </div>
      <div className="content">
        第百六条 本协议自用户创建钱包时生效，对协议双方具有约束力。
      </div>
      <div className="content">第百七条 本协议的最终解释权归平台所有。</div>
    </div>
  );
}
